module.exports = __webpack_public_path__ + "static/media/AppStore.2928664f.svg";